import React, { useContext, useEffect, useState } from "react";
import { CategoryContext } from "./CategoryContext";
import AppSettings from "../../../Settings/AppSettings";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import { Link, useHistory } from "react-router-dom";
import Label from "../../Common/components/Label";
import BootBoxManager from "../../../Common/BootBoxManager";
import { toast } from "react-toastify";
import GMSBorderlessButton from "../../Common/components/GMSBorderlessButton";
import { AppContext } from "../../../Context/AppContext";
import SkeletonElement from "./Shimmer/SkeletonElement";
import "./Category.css";
import Utils from "../../../Common/Utils";

const AddEditViewCategory = ({
  categoryName,
  setCategoryName,
  categoryTypeName,
  setCategoryTypeName,
  setCategoryDetailPageLoaded,
  showShimmer,
  setShowShimmer,
}) => {
  let blank_image_url =
    "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg";
  const {
    editingItem,
    setListReloadCounter,
    setEditingItem,
    categoryTypeList,
    categoryType,
    setCategoryType,
  } = useContext(CategoryContext);
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  let [loading, setLoading] = React.useState(false);
  let [loadingInfo, setLoadingInfo] = React.useState(null);
  let [categoryImage, setCategoryImage] = useState(blank_image_url);

  let [savingInfo, setsavingInfo] = React.useState({
    done: null,
    message: "",
  });

  const [disableButtons, setDisableButtons] = useState(true);

  let [errorMessage, setErrorMessage] = useState(null);
  let initialStateObject = {
    id: "",
    name: "",
    description: "",
    active: true,
    category_type_id: "",
    image_url: null
  };

  const validationOptions = {
    name: {
      required: true,
      minLength: 2,
      maxLength: 60,
      type: "alnum_with_spaces",
    },
    category_type_id: { required: true },
  };

  let [categoryDetail, setCategoryDetail] = useState(initialStateObject);
  let [categoryDetailCopy, setCategoryDetailCopy] =
    useState(initialStateObject);

  useEffect(() => {
    if (editingItem.id === "0") {
      setCategoryDetail(initialStateObject);
      setCategoryDetailCopy(initialStateObject);
      if (editingItem.category_type_id !== null) {
        setCategoryDetail({
          ...initialStateObject,
          category_type_id: editingItem.category_type_id,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem]);

  async function load_Category_detail() {
    setLoading(true);
    setLoadingInfo("Loading Category Details");
    let res = await ServiceWrapper.doGet(
      api_base_url + "category/details/" + editingItem.id,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      await setCategoryDetail(res?.data?.data[0]);
      setCategoryType({
        type: "c",
        id: res?.data?.data[0]?.id,
      });
      await setCategoryDetailCopy(res.data.data[0]);
      //AppContext.setLoading(false);
      const imageUrl = res.data.data[0].image_url || blank_image_url;
      const timestamp = new Date().getTime();
      const updatedImageUrl = `${imageUrl}?timestamp=${timestamp}`;
      setCategoryImage(updatedImageUrl);

      setLoading((prev) => !prev);
      setLoadingInfo(null);
      setDisableButtons(true);
      // setCategoryDetailAPICallCompleted(true);
    } else {
      setLoading((prev) => !prev);
      setErrorMessage(
        "Error while fetching details, Please try after some time."
      );
    }
  }

  async function hande_change(e) {
    let temp = { ...categoryDetail };

    temp[e.target.name] =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setCategoryDetail(temp);
    if (e.target.name === "image_url") {
      setCategoryImage(e.target.value);
    }
  }

  useEffect(() => {
    const validation = Utils.validate(categoryDetail, validationOptions);
    if (!validation[0]) setDisableButtons(true);
    // if (categoryDetail.name === "" || null || undefined) {
    //   setDisableButtons(true);
    // } else if (
    //   categoryDetail.category_type_id === undefined ||
    //   categoryDetail.category_type_id === ""
    // ) {
    //   setDisableButtons(true);
    // } else
    else if (
      JSON.stringify(categoryDetail) === JSON.stringify(initialStateObject)
    ) {
      setDisableButtons(true);
    } else if (
      JSON.stringify(categoryDetail) === JSON.stringify(categoryDetailCopy)
    ) {
      setDisableButtons(true);
    } else {
      setDisableButtons(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryDetail]);

  // function cancel_changes() {
  //   if (categoryDetail.id !== "0") {
  //     setCategoryDetail(categoryDetailCopy);
  //   } else setCategoryDetail(initialStateObject);
  // }

  async function save_changes() {
    setDisableButtons(true);
    setsavingInfo(null);
    let final_url;
    final_url = `${api_base_url}category/edit/${editingItem.id}`;
    if (editingItem.id === "0") {
      final_url = `${api_base_url}category/create`;
    }

    let res = await ServiceWrapper.doPost(
      final_url,
      categoryDetail,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (res.data.done) {
        setsavingInfo({
          done: true,
          message: res.data.message,
        });
        toast.success(res.data.message);
        if (editingItem.id === "0") {
          handle_reload_list(res?.data?.id);
        } else {
          handle_reload_list(editingItem.id);
          load_Category_detail();
        }
      } else {
        toast.error(res.data.message);
        setDisableButtons(false);
      }
    } else {
      setDisableButtons(false);
      setsavingInfo({
        done: false,
        message: "Error while saving, Please try after some time.",
      });
    }

    setTimeout(() => {
      setsavingInfo({
        done: null,
        message: "",
      });
    }, 5000);
  }

  function handle_reload_list(id) {
    setEditingItem({
      type: "c",
      form: "view",
      id: id,
    });
    if (
      !(
        categoryDetail.name === categoryDetailCopy.name &&
        categoryDetail.active === categoryDetailCopy.active &&
        categoryDetail.category_type_id === categoryDetailCopy.category_type_id
      )
    ) {
      setListReloadCounter((n) => n + 1);
    }

    copy_categoryType_detail();
  }

  function copy_categoryType_detail() {
    let temp = JSON.parse(JSON.stringify(categoryDetail));
    setCategoryDetailCopy(temp);
  }

  useEffect(() => {
    if (editingItem.form === "edit" && editingItem.id !== "0") {
      load_Category_detail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem]);

  const handleOnSaveClick = () => {
    if (
      (editingItem.form === "edit" && editingItem.id !== "0" &&
        AuthManager.getPermissions("gmscategory_update"))
      || (editingItem.form === "edit" && editingItem.id === "0" &&
        AuthManager.getPermissions("gmscategory_create"))) {
      save_changes();
    } else {
      toast.info("You do not have permission to save the category");
    }
  }

  const handleOnCancelClick = () => {
    setCategoryDetailPageLoaded(true);
    setCategoryImage("");
    editingItem.id === "0"
      ? setEditingItem({ type: categoryType.type, form: "view", id: categoryType?.id, })
      : setEditingItem({ type: "c", form: "view", id: categoryDetail.id, });
  }

  return (
    <React.Fragment>
      {editingItem.form === "view" ? (
        <CategoryDetails
          setCategoryName={setCategoryName}
          categoryTypeName={categoryTypeName}
          setCategoryTypeName={setCategoryTypeName}
          setCategoryDetailPageLoaded={setCategoryDetailPageLoaded}
          setCategoryDetail1={setCategoryDetail}
          setShowShimmer={setShowShimmer}
          showShimmer={showShimmer}
        />
      ) : (
        <>
          {loading && (
            <div className="">
              <div className="col-3 mb-4 p-1 skeleton"></div>
              <div className="border p-3 rounded">
                <div className="ps-3 row">
                  <div className="row col-6">
                    <div className="col-6 p-3 skeleton"></div>
                  </div>
                  <div className="col-6 justify-content-end ms-4 pb-3 row">
                    <div className="col-4 p-1 skeleton"></div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-10">
                    <div className="mb-4 p-3 skeleton"></div>
                    <div className="p-3 skeleton"></div>
                  </div>
                  <div className="col-2 p-2">
                    <div className="h-100 m-0 p-5 skeleton"></div>
                  </div>
                </div>
                <div className="col-10 mt-4 p-3 skeleton"></div>
                <div className="col-10 mt-4 p-5 skeleton"></div>
              </div>
              <div className="mt-5 p-3 skeleton"></div>
              <div className="mt-5 p-3 skeleton"></div>
              <div className="mt-5 p-3 skeleton"></div>
              <div className="mt-5 p-3 skeleton"></div>
              <div className="mt-5 p-3 skeleton"></div>
              <div className="mt-5 p-3 skeleton"></div>
              <div className="mt-5 p-3 skeleton"></div>
            </div>
          )}
          {!loading &&
            (errorMessage ? (
              <div className="alert alert-danger small p-2" role="alert">
                <span className="fas fa-exclamation-triangle" />
                &nbsp;
                <strong>{errorMessage}</strong>
              </div>
            ) : (
              <div className="mt-1">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb tw-ms-4">
                    <li className="breadcrumb-item tw-pointer-events-none">
                      <Link to="#">
                        <Label
                          message="Taxonomy"
                          fontSize={"0.75"}
                          fontWeight="400"
                          color="#5c5f62"
                        />
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      <Label
                        message={categoryTypeName ?? ""}
                        fontSize={"0.75"}
                        fontWeight="500"
                        color="#5c5f62"
                        onClick={() => {
                          setEditingItem({
                            type: "ct",
                            form: "view",
                            id: categoryDetail?.category_type_id,
                          });
                        }}
                      />
                    </li>
                    <li className="breadcrumb-item active tw-pointer-events-none" aria-current="page">
                      <Label
                        message={categoryName ?? ""}
                        fontSize={"0.75"}
                        fontWeight="500"
                        color="#5c5f62"
                      />
                    </li>
                  </ol>
                </nav>
                <div className="card border-1 mb-3 p-3 mb-5 bg-body">
                  <div className="d-flex justify-content-between">
                    {/* <h4>
                    {editingItem.id === "0" && "Create "}
                    {editingItem.id !== "0" && "Edit "}
                    Category
                  </h4> */}
                    <div>
                      <Label
                        message={`
                    ${editingItem.id !== "0" ? "Edit " : "Create "}
                    Category`}
                        fontSize={"1.125"}
                        fontWeight="500"
                      />
                      {editingItem.id !== "0" && (
                        <>
                          {" "}
                          <br />
                          <span
                            style={{
                              fontSize: "0.75rem",
                              color: "#000000",
                              fontFamily: "Noto Sans",
                              fontWeight: "500",
                            }}
                          >
                            UID&nbsp;
                          </span>
                          <Label
                            message={`${editingItem.id !== "0" ? editingItem.id : ""
                              }`}
                            fontSize={"0.875"}
                            fontFamily="Noto Sans"
                            fontWeight="400"
                            color="#5c5f62"
                          />{" "}
                        </>
                      )}
                    </div>

                    <div className="tw-flex tw-gap-2 tw-mt-2">
                      <button onClick={handleOnCancelClick} className="samll-outline-btn">Cancel</button>
                      <button disabled={disableButtons} onClick={handleOnSaveClick} className="small-filled-btn">Save</button>
                    </div>
                  </div>
                  <form>
                    <div className=" row mt-3">
                      <div className="col-sm-10">
                        <Label
                          message="Category Type"
                          htmlFor="category_type_id"
                          fontWeight="500"
                          fontSize={"0.875"}
                        />

                        <select
                          id="category_type_id"
                          className="form-select form-select-sm mt-1 mb-4 mb-2 shadow-none"
                          aria-label="Default select example"
                          style={{
                            fontSize: "0.8rem",
                            color: "black",
                            fontWeight: "500",
                            fontFamily: "Noto Sans",
                            border: `1px solid ${categoryDetail?.category_type_id
                              ? "#ced4da"
                              : "#c13e25"
                              }`,
                          }}
                          onChange={(e) => hande_change(e)}
                          name="category_type_id"
                          value={categoryDetail?.category_type_id}
                        >
                          <option value={""} id={"undefined"} selected={true}>
                            Select Category Type
                          </option>
                          {categoryTypeList.map((categoryType, index) => {
                            return (
                              <option
                                value={categoryType.id}
                                id={categoryType.id}
                                key={index}
                              >
                                {categoryType.name}
                              </option>
                            );
                          })}
                        </select>
                        <Label
                          message="Name"
                          htmlFor="name"
                          fontWeight="500"
                          fontSize={"0.875"}
                        />

                        <input
                          type="text"
                          className="form-control shadow-none mt-1"
                          id="name"
                          name="name"
                          style={{
                            fontSize: "0.8rem",
                            color: "black",
                            fontWeight: "500",
                            fontFamily: "Noto Sans",
                            border: `1px solid ${categoryDetail?.name?.length > 2
                              ? "#ced4da"
                              : "#c13e25"
                              }`,
                          }}
                          placeholder="Enter Category Name"
                          value={categoryDetail.name || ""}
                          onChange={(e) => hande_change(e)}
                          aria-describedby="nameHelp"
                          maxLength="60"
                          minLength="2"
                        />
                        <div id="nameHelp" className="form-text mb-4">
                          <Label
                            message="Name must be 2-60 characters long, contain letters,
                        numbers and spaces, and must not contain special
                        characters."
                            fontSize={"0.7"}
                            fontWeight="500"
                            color="#B0B0B0"
                            fontFamily="Noto Sans"
                          />
                        </div>
                        <Label
                          message="Image Url"
                          htmlFor="imageUrl"
                          fontWeight="500"
                          fontSize={"0.875"}
                          fontFamily="Noto Sans"
                        />

                        <input
                          type="text"
                          className="form-control mb-4 shadow-none"
                          id="imageUrl"
                          name="image_url"
                          style={{
                            fontSize: "0.875rem",
                            fontWeight: "500",
                            fontFamily: "Noto Sans",
                          }}
                          placeholder="Enter image Url"
                          value={categoryDetail.image_url || ""}
                          onChange={(e) => hande_change(e)}
                        />

                        <Label
                          message="Description"
                          htmlFor="description"
                          fontWeight="500"
                          fontSize={"0.875"}
                        />

                        <textarea
                          className="form-control shadow-none mt-1"
                          id="description"
                          name="description"
                          rows="3"
                          style={{
                            fontSize: "0.875rem",
                            fontWeight: "500",
                            fontFamily: "Noto Sans",
                          }}
                          placeholder="Enter description"
                          onChange={(e) => hande_change(e)}
                          value={categoryDetail.description || ""}
                        />
                      </div>

                      <div className="col col-sm-2 mt-4">
                        <img
                          src={categoryImage || blank_image_url}
                          className="img-fluid img-thumbnail cat-image"
                          key={new Date().getTime()}
                          alt="..."
                          style={{
                            border: "1px solid #f2f2f2",
                          }}
                        />
                      </div>
                    </div>

                    <div className="float-start">
                      {savingInfo !== null ? (
                        <>
                          {savingInfo.done ? (
                            <div
                              className="alert alert-primary bg-white small p-2"
                              role="alert"
                            >
                              <i className="far fa-check-circle" />
                              &nbsp;
                              <strong>{savingInfo.message}</strong>
                            </div>
                          ) : (
                            <>
                              {savingInfo.done === false && (
                                <div
                                  className="alert alert-danger small p-2"
                                  role="alert"
                                >
                                  <span className="fas fa-exclamation-triangle" />
                                  &nbsp;
                                  <strong>{savingInfo.message}</strong>
                                </div>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <div
                            className="alert alert-primary bg-white small p-2"
                            role="alert"
                          >
                            <span className="fas fa-circle-notch fa-spin" />
                            &nbsp;
                            <strong>Saving your Changes</strong>
                          </div>
                        </>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            ))}
        </>
      )}
    </React.Fragment>
  );
};
export default AddEditViewCategory;

const CategoryDetails = ({
  setCategoryName,
  categoryTypeName,
  setCategoryTypeName,
  setCategoryDetailPageLoaded,
  setCategoryDetail1,
  setShowShimmer,
  showShimmer,
}) => {
  const history = useHistory();
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  // let [showLoader, setShowLoader] = useState(false);

  const breadcurmbFontStyle = {
    textDecoration: "none",
    color: "grey",
    fontSize: ".8rem",
    fontWeight: "600",
  };
  const appData = useContext(AppContext);
  //const pm = new PermissionsManager();

  const { editingItem, setEditingItem } = useContext(CategoryContext);
  let blank_image_url =
    "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg";
  let [loading, setLoading] = React.useState({
    status: "",
    message: "",
  });
  let [categoryDetail, setCategoryDetail] = useState({});
  let [categoryImage, setCategoryImage] = useState(blank_image_url);

  const [clipText, setClipText] = useState(null);

  function handle_clipbord(text) {
    navigator.clipboard.writeText(text).then(() => setClipText(text));
  }

  function handle_url_clipbord(id) {
    const url = `${window.location.origin}${window.location.pathname}`;
    const categoryID = `/c/${id}`;
    if (url.includes(id)) {
      navigator.clipboard
        .writeText(`${url}`)
        .then(() => toast.success("Url Copied to clipboard"));
    } else {
      navigator.clipboard
        .writeText(`${url}${categoryID}`)
        .then(() => toast.success("Url Copied to clipboard"));
    }
  }

  useEffect(() => {
    load_Category_detail();
    setClipText(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem.id]);

  const { setListReloadCounter, setDeleteInfo, categoryTypeList } = useContext(CategoryContext);

  async function deleteCategory(id) {
    toast.info("Preparing to delete category");

    let res = await ServiceWrapper.doGet(
      api_base_url + "category/delete/" + id,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      if (res.data.done) {
        toast.success(res.data.message);
        if (
          editingItem !== null &&
          editingItem !== undefined &&
          editingItem.type === "c" &&
          editingItem.id === id
        ) {
          setEditingItem(null);
        }
        setListReloadCounter((n) => n + 1);
      } else {
        setDeleteInfo({
          status: "Error",
          message: "Deletion of Category Failed",
        });

        window["bootbox"].dialog({
          title: "Category Deletion Failure",
          closeButton: false,
          message:
            "<p>We are Sorry, We could not delete the selected category Below is more information.</p><p><strong>" +
            res.data.message +
            "</strong></p>",
          size: "medium",
          centerVertical: true,
          buttons: {
            ok: {
              label: "OK, I got it",
              className: "button-fill",
              callback: function () {
                console.log("Custom OK clicked");
              },
            },
          },
        });
      }
    } else {
      //setShowLoader((prev) => !prev);
      setDeleteInfo({
        status: "Error",
        message: "Error while deleting selected category!!",
      });
    }

    setTimeout(() => {
      setDeleteInfo({
        status: null,
        message: "",
      });
    }, 3000);
  }

  async function load_Category_detail() {
    //  pm.ProcessPermissions();
    setShowShimmer(true);
    setCategoryDetail(null);
    setLoading({ status: "loading", message: "Loading Category Details" });
    let res = await ServiceWrapper.doGet(
      `${api_base_url}category/details/${editingItem.id}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      setCategoryDetailPageLoaded(true);
      setShowShimmer(false);
      setLoading({ status: "success", message: "" });
      setCategoryDetail(res?.data?.data[0]);
      const imageUrl = res?.data?.data[0]?.image_url ?? blank_image_url;
      const timestamp = new Date().getTime();
      const updatedImageUrl = `${imageUrl}?timestamp=${timestamp}`;

      setCategoryImage(updatedImageUrl);

      setCategoryName(res?.data?.data[0]?.name);
    } else {
      setShowShimmer(false);
      setCategoryDetailPageLoaded(false);
      setLoading({ status: "Error", message: "Error while loading details" });
    }
  }

  const categoryContextData = useContext(CategoryContext);
  const categoryType = loading.status === "success" && categoryDetail
    ? categoryTypeList.find(type => type.id === categoryDetail.category_type_id)?.name || ""
    : "";

  useEffect(() => {
    if (categoryType) setCategoryTypeName(categoryType)
  }, [categoryType])

  return (
    <>
      <div className=" d-flex flex-column justify-content-between">
        {/* {showLoader && <Loader width="120px" height="120px" />} */}
        <div
          className="d-flex justify-content-between ps-0 pe-0 pb-2"
          style={{
            borderBottom: "1px solid #c9c9cf",
            paddingBottom: "0px",
            paddingTop: "0px",
          }}
        >
          <div className="ps-4 mt-2">
            <Label message="Categories" fontSize={"1.125"} fontWeight="600" />
          </div>
          <div
            className=" d-flex btn-group"
            style={{
              right: "6px",
              float: "right",
            }}
          >
            <button
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              className="button-outlined me-2"
            >
              Create
            </button>
            <ul className={`dropdown-menu`}>
              <li>
                <Link
                  to="#"
                  className="dropdown-item"
                  onClick={() => {
                    if (appData.pm.checkPermission("gmscategory_create")) {
                      categoryContextData.setEditingItem({
                        type: "ct",
                        form: "edit",
                        id: "0",
                      });
                    } else {
                      toast.info(
                        "You don't have permission to create the category type"
                      );
                    }
                  }}
                  style={{ fontSize: ".8rem" }}
                  href="#"
                >
                  Category Type
                </Link>
              </li>
              {12 > 0 && (
                <li>
                  <Link
                    to="#"
                    className="dropdown-item"
                    style={{ fontSize: ".8rem" }}
                    onClick={() => {
                      if (appData.pm.checkPermission("gmscategory_create")) {
                        categoryContextData.setEditingItem({
                          type: "c",
                          form: "edit",
                          id: "0",
                          category_type_id: undefined,
                        });
                      } else {
                        toast.info(
                          "You don't have permission to create the category"
                        );
                      }
                    }}
                    href="#"
                  >
                    Category
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>

        <nav className="col-12 ps-4 mt-2" aria-label="breadcrumb">
          <ol className="breadcrumb mt-1">
            <li className="breadcrumb-item tw-pointer-events-none">
              <Link
                style={breadcurmbFontStyle}
                to="#"
              >
                <Label
                  message="Taxonomy"
                  fontSize={"0.75"}
                  fontWeight="400"
                  color="#5c5f62"
                />
              </Link>
            </li>
            <li className="breadcrumb-item">
              <Link
                style={breadcurmbFontStyle}
                to="#"
                onClick={() => {
                  setEditingItem({
                    type: "ct",
                    form: "view",
                    id: categoryDetail?.category_type_id,
                  });
                }}
              >
                <Label
                  message={categoryTypeName}
                  fontSize={"0.75"}
                  fontWeight="400"
                  color="#5c5f62"
                />
              </Link>
            </li>
            {categoryTypeName && <li className="breadcrumb-item active tw-pointer-events-none" aria-current="page">
              <Label
                message={categoryDetail ? categoryDetail?.name : ""}
                fontSize={"0.75"}
                fontWeight="400"
                color="#5c5f62"
              />
            </li>}
          </ol>
        </nav>

        {showShimmer && (
          <div className="d-flex flex-wrap">
            {/* <Loader width="120px" height="120px" /> */}
            <div className="col-2 ps-5 ">
              <SkeletonElement type={"thumbnail"} />
            </div>
            <div className="col-10">
              <SkeletonElement type={"title"} />
              <SkeletonElement type={"text"} />
              <br />
              <SkeletonElement type={"text50"} />
              <SkeletonElement type={"text50"} />
            </div>
          </div>
        )}

        {loading.status === "Error" && (
          <div className="col-12 ps-0 pe-0 tw-flex-grow">
            <div className="card-body text-dark text-center ">
              <div className="default-page mt-5">
                <img
                  src={process.env.PUBLIC_URL + "/img/place_holder_no_data.svg"}
                  alt="logo"
                  className="tw-m-auto"
                  style={{
                    width: "auto",
                    height: "160px",
                    color: "#091caa",
                  }}
                />
                <br />
                <Label
                  message="No data found"
                  fontSize={"2"}
                  fontWeight="600"
                  color="#091caa"
                />
                <br />
                <Label
                  message="You can create category for the products."
                  fontSize={"0.75"}
                  fontWeight="500"
                />
                <br />
                <br />
                <div
                  className=" btn-group"
                  style={{
                    right: "6px",
                  }}
                >
                  <button
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    className="button-outlined"
                  >
                    Create Category
                  </button>

                  <ul className={`dropdown-menu`}>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item"
                        onClick={() => {
                          if (
                            appData.pm.checkPermission("gmscategory_create")
                          ) {
                            categoryContextData.setEditingItem({
                              type: "ct",
                              form: "edit",
                              id: "0",
                            });
                          } else {
                            toast.info(
                              "You don't have permission to create the category type"
                            );
                          }
                        }}
                        style={{ fontSize: ".8rem" }}
                        href="#"
                      >
                        Category Type
                      </Link>
                    </li>
                    {12 > 0 && (
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item"
                          style={{ fontSize: ".8rem" }}
                          onClick={() => {
                            if (
                              appData.pm.checkPermission("gmscategory_create")
                            ) {
                              categoryContextData.setEditingItem({
                                type: "c",
                                form: "edit",
                                id: "0",
                                category_type_id: undefined,
                              });
                            } else {
                              toast.info(
                                "You don't have permission to create the category"
                              );
                            }
                          }}
                          href="#"
                        >
                          Category
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}

        {loading.status === "success" && categoryDetail && (
          <>
            <div className="ms-2 ps-1">
              <div
                className="d-flex flex-wrap mb-3 px-3"
                style={{
                  border: "1px solid #c9cccf",
                  padding: "20px 10px 0px 0px",
                  borderRadius: "4px",
                }}
              >
                <div
                  className={`col col-sm-10 col-md-2 px-2 ${categoryDetail.image_url ? "pb-4" : "pb-5"
                    }`}
                  style={{
                    height: `${categoryDetail.image_url ? "" : "165px"}`,
                    width: `${categoryDetail.image_url ? "" : "146px"}`,
                  }}
                >
                  <img
                    src={categoryImage}
                    className="img-fluid img-thumbnail cat-image"
                    key={new Date().getTime()}
                    style={{
                      height: "150px",
                      width: "150px",
                      inlineSize: "fit-content",
                      backgroundColor: "transparent",
                    }}
                    alt="..."
                    loading="lazy"
                  />
                </div>

                <div className="col col-sm-12 col-md-10 px-2">
                  <div className="d-flex justify-content-between">
                    <div className="mb-0 w-auto">
                      <Label
                        message={categoryDetail.name || ""}
                        fontSize={"1.125"}
                        fontWeight="600"
                      />
                      <br />
                      <Label
                        message=""
                        fontSize={"0.875"}
                        padding="0!important"
                      />
                      <span
                        className=""
                        style={{
                          fontFamily: "Noto Sans",
                          fontWeight: 400,
                          fontSize: "0.875rem",
                          lineHeight: 1.5,
                          color: "#000000",
                        }}
                      >
                        {categoryDetail.description}
                      </span>
                    </div>

                    <div className="w-auto d-flex align-items-center">
                      <GMSBorderlessButton
                        name="Edit"
                        onClick={() => {
                          if (
                            appData.pm.checkPermission("gmscategory_update")
                          ) {
                            // if (AuthManager.getPermissions().gmscategory_update) {
                            setLoading((prve) => !prve);
                            setEditingItem({
                              type: "c",
                              form: "edit",
                              id: categoryDetail.id,
                            });
                          } else {
                            toast.info("You don't have permission to edit");
                          }
                        }}
                      />
                      &nbsp;&nbsp;&nbsp;
                      <div className="bd-highlight">
                        <li
                          className="nav-item dropdown"
                          style={{ listStyleType: "none" }}
                        >
                          <div role="group">
                            <i
                              id="btnGroupDrop1"
                              className="fas fa-ellipsis-v pt-1"
                              style={{
                                fontSize: "0.75rem",
                                cursor: "pointer",
                                color: "#091caa",
                              }}
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              onClick={() => null}
                            />

                            <div className="dropdown-menu p-0">
                              {/* <h6 class="dropdown-header">Dropdown header</h6> */}
                              <Link
                                className="dropdown-item"
                                to="#"
                                style={{ fontSize: "0.75rem" }}
                                onClick={() => {
                                  if (
                                    appData.pm.checkPermission(
                                      "gmscategory_delete"
                                    )
                                  ) {
                                    // if (
                                    //   AuthManager.getPermissions()
                                    //     .gmscategory_delete
                                    // ) {
                                    BootBoxManager.confirm(
                                      "",
                                      `
                                ${categoryDetail.name}
                                `,
                                      false,
                                      [deleteCategory, editingItem.id]
                                    );
                                  } else {
                                    toast.info(
                                      "You don't have permission to delete the category"
                                    );
                                  }
                                }}
                              >
                                Delete
                              </Link>
                              <Link
                                className="dropdown-item"
                                to="#"
                                style={{ fontSize: "0.75rem" }}
                                onClick={() => {
                                  handle_url_clipbord(categoryDetail.id);
                                }}
                              >
                                Share URL
                              </Link>
                            </div>
                          </div>
                        </li>
                      </div>
                    </div>
                  </div>
                  <br />
                  <p className="small mb-1">
                    <span style={{ fontSize: "" }} className="">
                      <span
                        style={{
                          fontSize: "0.875",
                          color: "#000000",
                          fontFamily: "Noto Sans",
                          fontWeight: "500",
                        }}
                      >
                        UID&nbsp;&nbsp;
                      </span>
                      <Label
                        message={`${categoryDetail.id || ""}`}
                        fontSize={"0.875"}
                        fontFamily="Noto Sans"
                        fontWeight="400"
                        color="#5c5f62"
                      />
                    </span>
                    &nbsp;&nbsp;
                    <i
                      className={`${clipText === null ? "far" : "fas"
                        } fa-clipboard`}
                      style={{
                        fontSize: "0.95rem",
                        cursor: "pointer",
                        color: "#091caa",
                      }}
                      onClick={() => handle_clipbord(categoryDetail.id)}
                    />
                    &nbsp;&nbsp;
                    <Label
                      message={clipText === null ? "" : "UID Copied"}
                      fontSize={"0.75"}
                      color="#488328"
                    />
                  </p>

                  <p className="small mb-3 mt-2">
                    <Link
                      to="#"
                      className="link-primary text-decoration-none"
                      onClick={() => {
                        history.push("/gms/products/list/" + categoryDetail.id);
                      }}
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "400",
                        color: "#091caa",
                        height: "5px",
                        cursor: "pointer",
                        fontFamily: "Noto Sans",
                      }}
                    >
                      {"View Products  >"}
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
